import React, { useContext, useMemo } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { Product, TrendingProduct } from 'src/types';
import ExpandableProductCardGrid from 'src/components/expandable-product-card-grid';
import { TRENDING_PRODUCT_CLICK } from 'src/globals/helpers/navigation-action';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

type Props = {
  trendingProducts?: Product['trendingProducts'];
};

export const TrendingProducts: React.FC<Props> = ({ trendingProducts }) => {
  const { t } = useContext(AppContext);

  const mappedProducts: Product[] | null = useMemo(() => {
    if (!trendingProducts) {
      return null;
    }
    return trendingProducts
      .filter((tp): tp is TrendingProduct => Boolean(tp))
      .filter((tp: TrendingProduct) => Boolean(tp.pathName))
      .map(product => ({
        id: Number(product.id),
        name: String(product.name),
        pathName: product.pathName ?? '',
        media: { first: product.imageUrl, count: 1 },
        priceSummary: { regular: product.price },
        classicFullPath: String(product.url),
        userReviewSummary: {
          rating: product.userReviewRating,
          count: product.userReviewCount,
        },
        conditions: [] as Product['conditions'],
      }));
  }, [trendingProducts]);

  if (!mappedProducts || mappedProducts.length === 0) {
    return null;
  }

  return (
    <ExpandableProductCardGrid
      products={mappedProducts}
      title={t('landing', 'trending-products.title')}
      ssrExpanded
      productNavigationAction={TRENDING_PRODUCT_CLICK}
      onProductCardClick={(data: { index: number; link: string }) =>
        trackInternalNavigationClick({
          scope: InternalNavigationScope.TRENDING_PRODUCTS_PRODUCT_CARD,
          nextPage: data.link,
          index: data.index,
        })
      }
    />
  );
};
